<template>
  <div>
    <page-title/>
    <search-form ref="form" @onSearch="onSearch">
      <template #columnPicker><column-picker :headers="transactionHeaders" @updateHeaders="updateHeaders"/></template>
    </search-form>
    <transactions-table :headers="transactionHeaders"/>
  </div>
</template>

<script>
  import ColumnPicker from '@molecules/ColumnPicker';

  import PageTitle from './MemberTransactions/PageTitle';
  import SearchForm from './MemberTransactions/SearchForm';
  import TransactionsTable from './MemberTransactions/TransactionsTable';
  // import queryParamable from '@mixins/queryParamable';
  import formattable from '@mixins/formattable';
  import moment from 'moment';
  import { useRoute, useStore } from '@vue3shims';
  import { onBeforeMount, onBeforeUnmount } from '@vue/composition-api';
  import { formatDate, toIso8601Date } from '@utils';
  import { useGroupSelector } from '@composables/useGroupSelector';
  import { useQueryParams } from '@composables/useQueryParams';
  import { ref, watch } from '@vue/composition-api';

  export default {
    mixins: [ formattable ],
    components: {
      ColumnPicker,
      PageTitle,
      SearchForm,
      TransactionsTable
    },
    setup() {
      const store = useStore();
      const route = useRoute();
      const eagerQueryParams = false;
      const defaultQueryParams = {
        fromDate: toIso8601Date(moment().subtract(7, 'd')),
        toDate: toIso8601Date(moment()),
        transactionType: 'ALL',
        userId: '',
      };
      const fetchData = async () => {
        return await store.dispatch('GET_MEMBER_TRANSACTIONS');
      }
      const transactionHeaders = ref([
        { text: 'Last Name', align: 'left', value: 'memberLastName' },
        { text: 'First Name', value: 'memberFirstName' },
        { text: 'EyeMed Member ID', value: 'eyemedMemberId', visible: false },
        { text: 'Client\'s Member ID', value: 'clientHealthId' },
        { text: 'Group', value: (item) => item.coverage.groupName + ' - ' + item.coverage.groupId },
        { text: 'Subgroup', value: (item) => item.coverage.subGroupName + ' - ' + item.coverage.subGroupId, visible: false },
        { text: 'Relationship', value: 'relationship' },
        { text: 'DOB', value: (item) => formatDate(item.memberDateOfBirth) },
        { text: 'Last 4 SSN', value: 'ssn', visible: false },
        { text: 'Submitted On', value: (item) => formatDate(item.createdDate) },
        { text: 'Submitted By', value: 'createdBy', visible: false },
        { text: 'Action', value: 'action' },
        { text: 'EM Batch', value: 'fileBoundId', visible: false },
      ])
      const {
        clearQueryParams,
        initQueryParams,
        pushQueryParams,
        queryParams,
      } = useQueryParams();

      const { selected } = useGroupSelector();

      const onSearch = async (opts) => {
        // console.log(`opts`, opts);
        await store.dispatch('LOAD_QUERY_PARAMS', {...route.query, ...opts});
        await pushQueryParams();
        await fetchData();
      }

      const updateHeaders = (headers) => {
        transactionHeaders.value = headers
      }

      onBeforeMount(async () => {
        await initQueryParams(defaultQueryParams, eagerQueryParams);
        await fetchData();
      });

      onBeforeUnmount(() => {
        clearQueryParams();
      });

      watch(selected, async () => {
        await fetchData();
      });

      return {
        defaultQueryParams,
        eagerQueryParams,
        transactionHeaders,
        onSearch,
        updateHeaders,
        pushQueryParams,
        queryParams,
      }
    }
  }
</script>
